export enum PageDefenseEnum {
  AUTH = 'auth',
  COMMON = 'common',
  NO_AUTH = 'noAuth',
}
